import type { Section, Sections } from './Sidebar';

export function getSection(
  sectionKey: string | number | undefined,
  sections: Sections,
): Section | undefined {
  if (sectionKey == null) return undefined;
  return sections.find((s) => s.key === sectionKey);
}
